import axios from "axios";
import { SecureStoragePlugin } from 'capacitor-secure-storage-plugin';
import { isPWA } from "src/utils/mobile";

//! локалка
// export const STRAPI_TOKEN = 'token';
// export const BACKEND_URL = 'http://localhost:1439'

//! prod
export const STRAPI_TOKEN = '';
export const BACKEND_URL = 'https://supply-mobile.napitkivmeste.ru'


export const baseUrl = `${BACKEND_URL}/api`;

export const getAuthConfig = async () => {
  let token: string | null = null;

  if (!isPWA()) {
    const result = await SecureStoragePlugin.get({ key: 'accessToken' });
    token = result.value;
  }

  const headers = {
    Accept: "application/json;odata=nometadata",
    "Content-Type": "application/json;odata=nometadata",
  };

  if (token) {
    headers.Authorization = `Bearer ${token}`;
  }
  return {
    headers,
    withCredentials: true,
  };
};

export const fetchStrapiData = async (modelName: string, params: Record<string, any> = {}) => {
  //! оптимизация для справочника
  if (modelName === 'mt-5-s-depends') {
    return fetchMt5SDependsList();
  }
  const hasSelection = Object.keys(params).some(
    (k) => k.startsWith('populate') || k.startsWith('fields')
  );
  const url = hasSelection ? `${baseUrl}/${modelName}` : `${baseUrl}/${modelName}?populate=*`;
  const authConfig = await getAuthConfig();
  return axios.get(url, {
    ...authConfig,
    params,
  });
};

export const fetchMt5SDependsList = async () => {
  const authConfig = await getAuthConfig();
  const response = await axios.get(`${baseUrl}/mt-5-s-depends-list`, authConfig);
  const { dicts, rows } = response.data;

  const expanded = (rows || []).map((r: any[]) => {
    const [id, locationId, departmentId, areaId, zoneIdx, typeIdx, checkListIdx] = r;
    return {
      id,
      Zone: dicts.zones[zoneIdx] ?? null,
      TypeAudit: dicts.types[typeIdx] ?? null,
      CheckList: dicts.checkLists[checkListIdx] ?? null,
      Location: locationId ? { id: locationId, Title: dicts.locations[locationId] ?? '' } : null,
      Department: departmentId ? { id: departmentId, Title: dicts.departments[departmentId] ?? '' } : null,
      Area: areaId ? { id: areaId, Title: dicts.areas[areaId] ?? '' } : null,
    };
  });

  return {
    data: {
      data: expanded,
      meta: {
        pagination: { page: 1, pageSize: expanded.length, pageCount: 1, total: expanded.length },
      },
    },
  };
};

export const fetchMt5SMainTable = async (params: Record<string, any>) => {
  const authConfig = await getAuthConfig();
  return axios.get(`${baseUrl}/mt-5-s-main-table`, {
    ...authConfig,
    params,
  });
};

//! для в «Моя команда»
export const fetchTeam5SCards = async (emails: string[], signal?: AbortSignal) => {
  const params: Record<string, any> = {
    'filters[$and][0][$or][0][isAudit][$null]': 'true',
    'filters[$and][0][$or][1][isAudit][$eq]': 'false',
    'fields[0]': 'id',
    'populate[Auditor][fields][0]': 'email',
    'populate[CoAuditor][fields][0]': 'email',
    'pagination[pageSize]': 500,
  };
  const authConfig = await getAuthConfig();
  emails.forEach((email, i) => {
    params[`filters[$and][1][$or][0][Auditor][email][$in][${i}]`] = email;
    params[`filters[$and][1][$or][1][CoAuditor][email][$in][${i}]`] = email;
  });
  return axios.get(`${baseUrl}/mt-5-s-cards`, {
    ...authConfig,
    params,
    signal,
  });
};

export const fetchMt5SReportChart = async (params: Record<string, any>) => {
  const authConfig = await getAuthConfig();
  return axios.get(`${baseUrl}/mt-5-s-report-chart`, {
    ...authConfig,
    params,
  });
};

export const fetchMt5SReportDone = async (params: Record<string, any>) => {
  const authConfig = await getAuthConfig();
  return axios.get(`${baseUrl}/mt-5-s-report-done`, {
    ...authConfig,
    params,
  });
};

export const fetchMt5SCardAudit = async (cardId: number) => {
  const authConfig = await getAuthConfig();
  return axios.get(`${baseUrl}/mt-5-s-card-audit`, {
    ...authConfig,
    params: { cardId, _t: Date.now() },
  });
};

export const fetchOne5SCardById = async (id: number) => {
  const authConfig = await getAuthConfig();
  return axios.get(`${baseUrl}/mt-5-s-cards`, {
    ...authConfig,
    params: { 'filters[id][$eq]': id, populate: '*' },
  });
};

export const fetch5SCardCopiedFrom = async (cardId: number) => {
  const authConfig = await getAuthConfig();
  return axios.get(`${baseUrl}/mt-5-s-cards`, {
    ...authConfig,
    params: {
      'fields[0]': 'id',
      'filters[id][$eq]': cardId,
      'populate[CopiedFromCard][fields][0]': 'id',
    },
  });
};

export const fetch5SInconsistencyFilesOne = async (inconsistencyDocumentId: string) => {
  const authConfig = await getAuthConfig();
  return axios.get(`${baseUrl}/mt-5-s-inconsistency-files`, {
    ...authConfig,
    params: {
      'filters[Inconsistency][documentId][$eq]': inconsistencyDocumentId,
      populate: '*',
    },
  });
};

export const fetchFilePreviewImages = async (fileId: number, path: string) => {
  const authConfig = await getAuthConfig();
  return axios.post(`${baseUrl}/md-documents-files/preview_path`, { id: fileId, path }, authConfig);
};

export const fetchFileBlob = async (fileUrl: string) => {
  const authConfig = await getAuthConfig();
  return axios.get(fileUrl, { ...authConfig, responseType: 'blob' });
};

export const fetch5SInconsistencyFiles = async (incDocumentIds: string[]) => {
  const authConfig = await getAuthConfig();
  const params: Record<string, any> = { populate: '*', 'pagination[pageSize]': 1000 };
  incDocumentIds.forEach((id, i) => {
    params[`filters[Inconsistency][documentId][$in][${i}]`] = id;
  });
  return axios.get(`${baseUrl}/mt-5-s-inconsistency-files`, { ...authConfig, params });
};

export const extractStrapiData = (response: any) => {
  if (response && response.data && response.data.data) {
    return response.data.data;
  }
  if (response && response.data) {
    return response.data;
  }
  return [];
};

export const addStrapiData = async (modelName: string, data: any) => {
  const formattedData = data.data ? data : { data };
  const authConfig = await getAuthConfig();
  return axios.post(`${baseUrl}/${modelName}`, formattedData, authConfig).catch((error) => {
    console.error('Ошибка API:', error.response?.data || error.message);
    throw error;
  });
};

export const updateStrapiData = async (modelName: string, documentId: string, data: any) => {
  const formattedData = data.data ? data : { data };
  const authConfig = await getAuthConfig();
  return axios.put(`${baseUrl}/${modelName}/${documentId}`, formattedData, authConfig).catch((error) => {
    console.error('Ошибка API:', error.response?.data || error.message);
    throw error;
  });
};

export const deleteStrapiData = async (modelName: string, documentId: string) => {
  const authConfig = await getAuthConfig();
  return axios.delete(`${baseUrl}/${modelName}/${documentId}`, authConfig).catch((error) => {
    console.error('Ошибка API:', error.response?.data || error.message);
    throw error;
  });
};

export const deleteMt5SCard = async (cardId: number) => {
  const authConfig = await getAuthConfig();
  return axios.delete(`${baseUrl}/mt-5-s-card-delete/${cardId}`, authConfig).catch((error) => {
    console.error('Ошибка API:', error.response?.data || error.message);
    throw error;
  });
};

export const uploadFileToStrapi = async (file: File) => {
  const authConfig = await getAuthConfig();
  const formData = new FormData();
  formData.append('files', file);
  return axios.post(`${baseUrl}/upload`, formData, {
    ...authConfig,
    headers: {
      ...authConfig.headers,
      'Content-Type': 'multipart/form-data',
    },
  });
};

export const deleteFileFromStrapi = async (uploadId: number) => {
  const authConfig = await getAuthConfig();
  return axios.delete(`${baseUrl}/upload/files/${uploadId}`, authConfig);
};
